export type MarkdownRendererVariant = "default" | "summary";

// AI summaries are read as documents, so they breathe more between blocks than chat replies do
export const markdownSpacing: Record<MarkdownRendererVariant, { paragraph: string; listItem: string }> = {
  default: { paragraph: "mb-2 last:mb-0", listItem: "mb-1 pl-2" },
  summary: { paragraph: "mb-3 last:mb-0", listItem: "mb-3 pl-2" },
};
